module.exports = __webpack_public_path__ + "static/media/button.0b08639f.mp3";